import useSWR, { mutate } from 'swr'

import { Loading } from '@/components/Loading'
import { SettingsPage, SettingsSection } from '@/containers/Settings/SettingsLayout'
import { apiFetcher } from '@/data/fetcher'
import { AccountFeaturesForm } from '@/forms/AccountFeaturesForm/AccountFeaturesForm'
import { AccountForm } from '@/forms/AccountForm/AccountForm'
import { useRoleCheck } from '@/hooks/useRoleCheck'
import { Settings } from '@/interfaces/Settings'
import { Role } from '@/types/User'

export default function SettingsAccountPage() {
  const { data: settings, isLoading } = useSWR<Settings>('/api/v2/settings', apiFetcher)
  const isOwner = useRoleCheck(Role.owner)

  return (
    <SettingsPage
      title="Účet a moduly"
      description="Název účtu a volitelné části aplikace."
      breadcrumbHref="/settings/account"
    >
      {isLoading && <Loading />}

      {settings && (
        <>
          <SettingsSection
            title="Název účtu"
            description="Název je důležitý jen tehdy, když máte přístup do více účtů a přepínáte mezi nimi."
          >
            <AccountForm defaultValues={settings.account} />
          </SettingsSection>

          {isOwner && (
            <SettingsSection
              title="Moduly"
              description="Zapněte jen to, co opravdu používáte. Vypnuté moduly zmizí z menu."
            >
              <AccountFeaturesForm
                enabledFeatures={settings.features}
                onSuccess={() => mutate('/api/v2/settings')}
              />
            </SettingsSection>
          )}
        </>
      )}
    </SettingsPage>
  )
}
